/*!
 * Copyright 2025 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { useEffect, useState } from "react";

import NoLegacySupport from "./NoLegacySupport";
import NoLegacySupportForProjectsRenkulabIo from "./NoLegacySupportForProjectsRenkulabIo";

export default function NoLegacySupportForProjects() {
  const [isRenkulabIo, setIsRenkulabIo] = useState(false);
  useEffect(() => {
    const hostname = window.location.hostname;
    if (
      hostname === "renkulab.io" ||
      hostname.endsWith(".renkulab.io") ||
      hostname === "dev.renku.ch" ||
      hostname.endsWith(".dev.renku.ch")
    ) {
      // TODO: fix react-hooks/set-state-in-effect
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setIsRenkulabIo(true);
    }
  }, []);

  return isRenkulabIo ? (
    <NoLegacySupportForProjectsRenkulabIo />
  ) : (
    <NoLegacySupport />
  );
}
